import { AlertOutlineIcon } from '@atgfr8/icons';
export const ReeferWarning = () => {
  return (
    <div class="w-full rounded-lg px-2 py-1 mb-4 border-solid border-[#f7b151] border-2 bg-[#fff8e1] font-roboto text-sm ">
      <div class="flex items-center gap-x-2">
        <AlertOutlineIcon color="#f7b151" />
        <div class="flex flex-col w-full">
          Reefer settings are used for tech tracking. Updating these details
          will automatically update tracking information.
        </div>
      </div>
    </div>
  );
};
